import { getSearchParams } from '@wix/package-picker-shared';
import { createModuleExtension } from '@wix/premium-fed-sdk/@premium-module';
import React from 'react';
import { createBrowserRouter, RouterProvider, useLocation, useNavigate, useRouteError } from 'react-router-dom';
import { EclipsePackagePickerSteps } from '../types/types';
function RouterErrorHandler() {
  const unknownError = useRouteError();
  console.error('[RouterErrorHandler] Route error:', unknownError);
  throw unknownError;
  return null;
}
export const RouterExtension = createModuleExtension(routes => {
  return {
    extensionName: 'RouterExtension',
    internals: {
      hooks: {
        useChangeRoute: () => {
          const navigate = useNavigate();
          return step => {
            const {
              allSearchParams
            } = getSearchParams();
            // Use absolute path to replace current route instead of concatenating
            navigate('/' + step + '?' + allSearchParams.toString());
          };
        },
        useCurrentStep: () => {
          const location = useLocation();
          const pathname = location.pathname;
          // Extract the last segment from the pathname
          // Example: '/premium-development-playground/artifact/package-picker-eclipse/select-plan' -> 'select-plan'
          const segments = pathname.split('/').filter(Boolean);
          const lastSegment = segments[segments.length - 1] || EclipsePackagePickerSteps.SELECT_PLAN;
          return lastSegment;
        }
      },
      components: {
        AppRouter: _ref => {
          let {
            basename
          } = _ref;
          const routeObjects = Array.from(routes.entries()).map(_ref2 => {
            let [step, ComponentRoute] = _ref2;
            return {
              path: String(step),
              element: /*#__PURE__*/React.createElement(ComponentRoute, null),
              errorElement: /*#__PURE__*/React.createElement(RouterErrorHandler, null)
            };
          });
          const router = createBrowserRouter(routeObjects, {
            basename
          });
          return /*#__PURE__*/React.createElement(RouterProvider, {
            router: router
          });
        }
      }
    }
  };
});
//# sourceMappingURL=router.extension.js.map